import Visualisation from "./Visualisation";
import {transformData} from "./transform-data";
import {useState} from "react";
import './index.css'
import {ReactComponent as ServiceCallVisualisationIcon} from './images/gantt-chart-svgrepo-com.svg'


const EmptyState = () => {
    return (
        <div>
            <div className="emptyState_introMessage">
                <p>
                    This plugin provides a timeline visualisation of the service calls done by AGG during the execution
                    of a
                    GraphQL query.
                </p>
                <p>
                    This is still in Beta and all feedback is appreciated! Reach out to <a
                    href="https://atlassian.enterprise.slack.com/archives/CFG45A3C0">#help-graphql-gateway</a> if you
                    have issues or suggestions ;-).
                </p>
                <p>
                    This plugin is visible only in staging environment, and AGG responses from production cannot be used
                    as they lack the latency extension fields necessary to create the timeline.
                </p>
            </div>

            <ol className="emptyState_copyPasteMessage">
                <li>Execute a query normally in AGG staging
                </li>
                <li>Copy/paste a complete JSON GraphQL response directly into this
                    section (just click anywhere here and paste it)
                </li>
                <li>The timeline visualisation should appear immediately</li>
            </ol>
        </div>
    )
}

const ServiceCallVisualisation = () => {
    const [data, setData] = useState(null)

    const handlePaste = (e) => {
        try {
            const text = e.clipboardData.getData('Text')

            const json = JSON.parse(text)

            const latencyData = json?.extensions?.gateway?.httpCallLatency

            if (latencyData == null) {
                alert('The GraphQL response doesn\'t contain a "extensions/gateway/httpLatency" field.')
                return
            }

            setData(transformData(latencyData))

        } catch (error) {
            console.log(error)
            console.log('This doesn\'t look like a valid GraphQL response in JSON format')
            alert('Error parsing GraphQL response.')
        }
    }

    const handleClear = () => {
        setData(null)
    }

    return <div className="serviceCallPluginContainer" onPaste={handlePaste}>
        {data && <div>
            <Visualisation data={data}/>
            <button type="button" className={"clearButton"} onClick={handleClear}>Clear</button>
        </div>}
        {!data && <EmptyState/>}
    </div>


}

export default ServiceCallVisualisation
export {
    ServiceCallVisualisationIcon
}

